{
  "name": "poe-code",
  "version": "3.0.410",
  "description": "CLI tool to configure Poe API for developer workflows.",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./memory": {
      "types": "./packages/memory/dist/index.d.ts",
      "import": "./packages/memory/dist/index.js"
    },
    "./agent": {
      "types": "./dist/agent.d.ts",
      "import": "./dist/agent.js"
    },
    "./skills": {
      "types": "./dist/skills.d.ts",
      "import": "./dist/skills.js"
    }
  },
  "workspaces": [
    "packages/*"
  ],
  "scripts": {
    "build": "turbo run build && npm run codegen:plan-schemas && npm run codegen:harness-schemas && tsc -p tsconfig.build.json && node scripts/generate-bin-wrappers.mjs && node scripts/bundle.mjs",
    "build:deps": "node scripts/list-workspace-deps.mjs",
    "codegen:python-types": "tsx scripts/generate-agent-spawn-py-types.ts",
    "codegen:check:python-types": "tsx scripts/generate-agent-spawn-py-types.ts --check",
    "install:py-poe-spawn": "pip install -e packages/py-poe-spawn",
    "predev": "turbo run build --output-logs=errors-only --log-prefix=none --verbosity=0",
    "dev": "tsx --import ./scripts/register-template-loader.mjs src/index.ts",
    "start": "node dist/bin.cjs",
    "dev:bundle": "npm run build && node dist/bin.cjs",
    "test": "turbo run test:unit --concurrency=1 --",
    "test:unit": "vitest run",
    "test:postinstall-lifecycle": "vitest run --config vitest.postinstall.config.ts",
    "typecheck": "npm run lint:types",
    "check:semver": "node -e \"const semver=require('semver'); const pkg=require('./package.json'); if(!semver.valid(pkg.version)){console.error('Invalid semver version in package.json:', pkg.version); process.exit(1);}\"",
    "lint": "npm run lint:eslint && npm run lint:types && npm run lint:workflows",
    "lint:workflows": "(command -v actionlint > /dev/null || bash scripts/setup-actionlint.sh) && (command -v actionlint > /dev/null && actionlint || ./actionlint)",
    "lint:packages": "tsx packages/package-lint/src/cli.ts",
    "lint:eslint": "eslint . --ext ts",
    "lint:types": "tsc -p tsconfig.build.json --noEmit",
    "labels:generate": "tsx scripts/generate-labels.ts",
    "screenshot": "tsx scripts/screenshot.ts",
    "screenshot-poe-code": "tsx scripts/screenshot.ts --poe-code",
    "generate:design-docs": "turbo run generate:docs --filter=toolcraft-design",
    "generate:design-docs:all": "npm run generate:design-docs:all -w toolcraft-design",
    "format": "prettier --check .",
    "format:write": "prettier --write .",
    "watch:diff": "tsx local_scripts/watch-diff.ts",
    "test:integration": "vitest run tests/integration/",
    "test:workflows": "bats .github/workflows/test/workflows.bats",
    "test:workflows:fast": "bats --filter 'dry-run' .github/workflows/test/workflows.bats",
    "test:workflows:all": "bash scripts/test-workflows.sh",
    "test:workflows:ci": "ACT_FULL=1 bash scripts/test-workflows.sh",
    "test:record": "POE_SNAPSHOT_MODE=record npm run test:integration",
    "test-generate": "tsx scripts/test-generate.ts",
    "snapshots": "tsx scripts/snapshots.ts",
    "snapshots:list": "npm run snapshots -- list",
    "snapshots:refresh": "npm run snapshots -- refresh",
    "snapshots:delete": "npm run snapshots -- delete",
    "snapshots:list:stale": "npm run snapshots -- list --stale",
    "snapshots:delete:stale": "npm run snapshots -- delete --stale",
    "e2e": "vitest run --config e2e/vitest.config.ts",
    "e2e:verbose": "E2E_VERBOSE=1 vitest run --config e2e/vitest.config.ts --reporter=verbose",
    "e2e:cleanup": "tsx packages/e2e-test-runner/scripts/cleanup.ts",
    "e2e:cleanup:aggressive": "tsx packages/e2e-test-runner/scripts/cleanup.ts --aggressive",
    "e2e:cache:clear": "rm -rf ~/.cache/poe-e2e",
    "prepack": "npm run build",
    "prepare": "husky",
    "install-local-package": "npm pack --pack-destination /tmp && npm install -g /tmp/poe-code-*.tgz && rm /tmp/poe-code-*.tgz",
    "smoke": "tsx scripts/smoke-test.ts",
    "smoke:verbose": "tsx scripts/smoke-test.ts --verbose",
    "metric:test_count": "node scripts/metric-test-count.mjs",
    "metric:test_duration": "node scripts/metric-test-duration.mjs",
    "demo:dashboard": "tsx packages/toolcraft-design/src/dashboard/demo.ts",
    "demo:explorer": "tsx packages/toolcraft-design/src/explorer/demo.ts",
    "replay": "tsx packages/agent-spawn/src/acp/replay-cli.ts",
    "codegen:plan-schemas": "tsx scripts/generate-plan-schemas.ts",
    "codegen:harness-schemas": "tsx scripts/generate-harness-schemas.ts",
    "smoke:toolcraft-standalone": "node scripts/verify-toolcraft-standalone.mjs",
    "sync-skills": "tsx scripts/sync-skills.ts",
    "postinstall": "node scripts/postinstall-sync-skills.mjs"
  },
  "bin": {
    "poe": "dist/bin.cjs",
    "poe-code": "dist/bin.cjs",
    "poe-code-configure": "dist/bin.cjs",
    "poe-claude": "dist/bin/poe-claude.js",
    "poe-codex": "dist/bin/poe-codex.js",
    "poe-opencode": "dist/bin/poe-opencode.js",
    "poe-agent": "dist/bin/poe-agent.js",
    "poe-superintendent-mcp": "packages/superintendent/dist/mcp.js",
    "tiny-oauth-test-server": "packages/tiny-oauth-test-server/dist/cli.js",
    "tiny-stdio-mcp-test-server": "packages/tiny-stdio-mcp-test-server/dist/cli.js"
  },
  "files": [
    "dist",
    "packages/agent-mcp-config/dist",
    "packages/agent-skill-config/dist",
    "packages/config-mutations/dist",
    "packages/toolcraft-design/dist",
    "packages/memory/dist",
    "scripts/postinstall-sync-skills.mjs",
    "packages/superintendent/dist",
    "packages/tiny-oauth-test-server/package.json",
    "packages/tiny-stdio-mcp-server/dist",
    "packages/tiny-stdio-mcp-test-server/package.json",
    "packages/acp-telemetry/dist",
    "packages/agent-child-process/dist",
    "packages/agent-code-review/dist",
    "packages/agent-defs/dist",
    "packages/agent-eval/dist",
    "packages/agent-harness/dist",
    "packages/agent-harness-tools/dist",
    "packages/agent-gaslight/dist",
    "packages/agent-traces/dist",
    "packages/agent-hook-config/dist",
    "packages/agent-human-in-loop/dist",
    "packages/maestro/dist",
    "packages/safejs/dist",
    "packages/agent-spawn/dist",
    "packages/auth-store/dist",
    "packages/braintrust/dist",
    "packages/cached-resource/dist",
    "packages/config-extends/dist",
    "packages/e2e-test-runner/dist",
    "packages/experiment-loop/dist",
    "packages/frontmatter/dist",
    "packages/frontmatter/package.json",
    "packages/github-review/dist",
    "packages/github-workflows/dist",
    "packages/maestro-tui/dist",
    "packages/markdown-reader/dist",
    "packages/mcp-oauth/dist",
    "packages/opencode-poe-auth/dist",
    "packages/package-lint/dist",
    "packages/pipeline/dist",
    "packages/plan-browser/dist",
    "packages/poe-acp-client/dist",
    "packages/poe-agent/dist",
    "packages/poe-code-config/dist",
    "packages/poe-oauth/dist",
    "packages/process-launcher/dist",
    "packages/process-runner/dist",
    "packages/providers/dist",
    "packages/ralph/dist",
    "packages/runner-e2b/dist",
    "packages/task-list/dist",
    "packages/terminal-pilot/dist",
    "packages/terminal-pilot-mcp/dist",
    "packages/terminal-png/dist",
    "packages/terminal-png-mcp/dist",
    "packages/tiny-http-mcp-oauth-test-server/package.json",
    "packages/tiny-http-mcp-oauth-test-server/dist",
    "packages/tiny-http-mcp-server/package.json",
    "packages/tiny-http-mcp-server/dist",
    "packages/tiny-mcp-client/dist",
    "packages/tiny-oauth-test-server/dist",
    "packages/tiny-stdio-mcp-test-server/dist",
    "packages/tokenfill/dist",
    "packages/toolcraft/dist",
    "packages/toolcraft-codemode/dist",
    "packages/toolcraft-landing-page/dist",
    "packages/toolcraft-openapi/dist",
    "packages/toolcraft-schema/dist",
    "packages/workspace-resolver/dist",
    "packages/worktree/dist"
  ],
  "engines": {
    "node": ">=18.18"
  },
  "packageManager": "npm@10.9.2",
  "dependencies": {
    "ajv": "^8.20.0",
    "chalk": "^5.6.2",
    "commander": "^13.1.0",
    "console-table-printer": "^2.15.0",
    "diff": ">=8.0.3",
    "e2b": "2.2.1",
    "fast-glob": "^3.3.3",
    "fast-string-width": "^3.0.2",
    "fast-wrap-ansi": "^0.2.0",
    "gray-matter": "^4.0.3",
    "ignore": "^5.3.2",
    "jose": "^6.1.3",
    "jsonc-parser": "^3.3.1",
    "mustache": "^4.2.0",
    "openai": "^6.34.0",
    "parse-duration": "^2.1.5",
    "semver": "^7.7.4",
    "shell-quote": "^1.8.4",
    "simple-git": "^3.36.0",
    "smol-toml": "^1.6.0",
    "tiktoken": "^1.0.22",
    "tiny-stdio-mcp-server": "^0.1.0",
    "toolcraft": "^0.0.51",
    "ts-morph": "^27.0.2",
    "turndown": "^7.2.4",
    "uri-template": "^2.0.0",
    "uri-template-lite": "^23.4.0",
    "yaml": "^2.8.2"
  },
  "optionalDependencies": {
    "braintrust": "^3.17.0"
  },
  "devDependencies": {
    "@eslint/js": "^9.0.0",
    "@modelcontextprotocol/sdk": "^1.26.0",
    "@poe-code/acp-telemetry": "*",
    "@poe-code/agent-child-process": "*",
    "@poe-code/agent-defs": "*",
    "@poe-code/agent-eval": "*",
    "@poe-code/agent-gaslight": "*",
    "@poe-code/agent-harness": "*",
    "@poe-code/agent-harness-tools": "*",
    "@poe-code/agent-hook-config": "*",
    "@poe-code/agent-human-in-loop": "*",
    "@poe-code/agent-mcp-config": "*",
    "@poe-code/agent-skill-config": "*",
    "@poe-code/agent-spawn": "*",
    "@poe-code/agent-traces": "*",
    "@poe-code/braintrust": "*",
    "@poe-code/cached-resource": "*",
    "@poe-code/config-extends": "*",
    "@poe-code/config-mutations": "*",
    "@poe-code/e2e-test-runner": "*",
    "@poe-code/experiment-loop": "*",
    "@poe-code/frontmatter": "*",
    "@poe-code/github-workflows": "*",
    "@poe-code/maestro": "*",
    "@poe-code/maestro-tui": "*",
    "@poe-code/markdown-reader": "*",
    "@poe-code/memory": "*",
    "@poe-code/package-lint": "*",
    "@poe-code/pipeline": "*",
    "@poe-code/plan-browser": "*",
    "@poe-code/poe-acp-client": "*",
    "@poe-code/poe-agent": "*",
    "@poe-code/poe-code-config": "*",
    "@poe-code/process-launcher": "*",
    "@poe-code/process-runner": "*",
    "@poe-code/providers": "*",
    "@poe-code/py-poe-spawn": "*",
    "@poe-code/ralph": "*",
    "@poe-code/runner-e2b": "*",
    "@poe-code/safejs": "*",
    "@poe-code/superintendent": "*",
    "@poe-code/task-list": "*",
    "@poe-code/workspace-resolver": "*",
    "@poe-code/worktree": "*",
    "@types/mustache": "^4.2.6",
    "@types/node": "^25.2.2",
    "@types/semver": "^7.7.1",
    "@vitest/coverage-v8": "^3.2.6",
    "agent-code-review": "*",
    "agent-stash": "*",
    "auth-store": "*",
    "bats": "^1.13.0",
    "eslint": "^9.0.0",
    "eslint-config-prettier": "^10.1.8",
    "github-review": "*",
    "globals": "^17.3.0",
    "husky": "^9.1.7",
    "mcp-oauth": "*",
    "memfs": "^4.56.10",
    "opencode-poe-auth": "*",
    "poe-oauth": "*",
    "prettier": "^3.8.1",
    "terminal-pilot": "^0.0.1",
    "terminal-pilot-mcp": "*",
    "terminal-png": "*",
    "terminal-png-mcp": "*",
    "tiny-http-mcp-oauth-test-server": "*",
    "tiny-http-mcp-server": "*",
    "tiny-mcp-client": "*",
    "tiny-oauth-test-server": "*",
    "tiny-stdio-mcp-server": "*",
    "tiny-stdio-mcp-test-server": "*",
    "tokenfill": "*",
    "toolcraft": "*",
    "toolcraft-codemode": "*",
    "toolcraft-design": "*",
    "toolcraft-landing-page": "*",
    "toolcraft-openapi": "*",
    "toolcraft-schema": "*",
    "tsx": ">=4.21.0",
    "turbo": "^2.9.18",
    "typescript": "^5.9.3",
    "typescript-eslint": "8.55.0",
    "vite": "6.4.3",
    "vitest": "^3.2.6"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/poe-platform/poe-code.git"
  },
  "overrides": {
    "eslint-visitor-keys": "4.2.1",
    "esbuild": "0.28.1",
    "glob": "10.5.0",
    "ini": "5.0.0",
    "toml": "3.0.0",
    "vite": "6.4.3"
  }
}
